module.exports = __webpack_public_path__ + "img/ca.d2e03f6c.svg";